import { zodResolver } from "@hookform/resolvers/zod";
import "react-toastify/dist/ReactToastify.css";
import { motion } from "framer-motion";
import { childVariantsStepper } from "../../animation/RoutesAnimations";
import { useForm } from "react-hook-form";
import SellerFormStep1 from "../../components/seller-form-steps/SellerFormStep1";
import SellerFormStep3 from "../../components/seller-form-steps/SellerFormStep3";
import customZ from "../../utils/setZodCustomMessages";
import StepsTitle from "../../components/Stepper/StepsTitle";
import SellerFormStep2 from "../../components/seller-form-steps/SellerFormStep2";
import BankAccount from "../../components/seller-form-steps/BankAccount";
import ConfirmInfo from "../../components/seller-form-steps/ConfirmInfo";
import SellerFormStep7 from "../../components/seller-form-steps/SellerFormStep7";
import SellerFormStep8 from "../../components/seller-form-steps/SellerFormStep8";
import Guarantee from "../../components/seller-form-steps/GuaranteeForm";
import { useEffect, useRef, useState } from "react";
import { axiosPrivate, CustomAxiosRequestConfig } from "../../api/axios";
import { STORE_CHECK_POLICY, STORE_HOME_CONTEXT } from "../../api/apiClient";
import AcceptSellerPolicy from "../../components/login/AcceptSellerPolicy";
export interface IFormData {
  id: any;
  product_group_uid: any;
  cardNumber: string;
  name: string;
  telephone_number: string;
  phone_number_sec?: string;
  postal_code: string;
  city: any;
  cityDetails: string;
  store_image: File | string;
  store_doc_img: File | string;
  first_name: string;
  last_name: string;
  phonenumber: number | string | null;
  national_id: string;
  birth_date: Date;
  birth_datererererer: Date;
  gender: "m" | "f" | undefined;
  marital_status: "SINGLE" | "MARRIED" | undefined;
  father_name: string;
  id_card: File | string;
  storeAddress: string;
  license_image: File | string;
  product_group_uid_list: string[];
  job_category_uid: string;
  store_uid: string;
  license_type: string;
  guild_id: string;
  isic_code: string;
  date_of_issuance: any;
  expiry_date: any;
  address: string;
  account_number: number; //bar asace api taghir kardan!
  IBAN: number;
  bank_uid: string;
  branch_code: string;
  bank_card_number: string;
  logo: File | string;
  national_code: string | null;
  tax_code: string | null;
  nationalCodeTaxCode: any;
  store_group_uid: any;
  operation_code?: any;
  lat: any;
  lng: any;
}

const step3Schema = customZ.object({});
const step4Schema = customZ.object({});
const step5Schema = customZ.object({});
const step6Schema = customZ.object({});
const step7Schema = customZ.object({});
const step8Schema = customZ.object({});

function SellerStepper({ formNo, setFormNo }: any) {
  const {
    control,
    formState: { errors },
  } = useForm<IFormData>({
    resolver: (data, context, options) => {
      return zodResolver(
        formNo === 3
          ? step3Schema
          : formNo === 1
          ? step4Schema
          : formNo === 5
          ? step5Schema
          : formNo === 6
          ? step6Schema
          : formNo === 4
          ? step7Schema
          : step8Schema
      )(data, context, options);
    },
  });

  const [storeUid, setStoreUid] = useState<string>("");
  const [storeState, setStoreState] = useState<string>("");
  const [storeStateConfirmInfo, setStoreStateConfirmInfo] =
    useState<string>("");
  const access_token = localStorage.getItem("access_token");
  const store_uid = localStorage.getItem("selected_store_uid");
  const [accepted, setAccepted] = useState<boolean>();
  const modalContentRef = useRef<HTMLDivElement>(null);

  const getPolicy = async () => {
    try {
      const response = await axiosPrivate.get(STORE_CHECK_POLICY, {
        headers: {
          // prettier-ignore
          "accept": "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });

      if (response?.status >= 200 && response?.status < 300) {
        setAccepted(response?.data?.data?.accepted);
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    getPolicy();
  }, [accepted]);

  const handleRulesAccepted = () => {
    setAccepted(!accepted);
  };

  const storeUserContextAPI = async () => {
    try {
      const storeUserContextAPIResponse = await axiosPrivate.get(
        STORE_HOME_CONTEXT(store_uid),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
          },
          withCredentials: true,
          globalErrorHandler: false,
        } as CustomAxiosRequestConfig
      );
      setStoreState(storeUserContextAPIResponse?.data?.data?.store_state);

      if (
        storeUserContextAPIResponse.status >= 200 &&
        storeUserContextAPIResponse.status < 300
      ) {
        if (
          storeUserContextAPIResponse?.data?.data?.store_state !== null ||
          storeUserContextAPIResponse?.data?.data?.store_state !== undefined
        ) {
          setFormNo(5);
        }
        if (storeUserContextAPIResponse?.data?.data?.store_state === "ACTIVE") {
          setFormNo(1);
        }
        if (
          storeUserContextAPIResponse?.data?.data?.store_state ===
          "NOT_VERIFIED"
        ) {
          setFormNo(1);
        }
      }
    } catch (error) {
      setFormNo(1);

      console.error("Error fetching contextResponse", error);
    }
  };
  useEffect(() => {
    store_uid && storeUserContextAPI();
  }, []);

  const seller_state = localStorage.getItem("seller_state");

  useEffect(() => {
    if (seller_state !== undefined) {
      if (
        seller_state === "PEND_FOR_VERIFY" ||
        seller_state === "REJECTED" ||
        seller_state === "ACTIVE"
      ) {
        setFormNo(5);
      }
    }
  }, []);

  return (
    <motion.div className=" ">
      <div className=" pt-4 z-10 ">
        <div className=" pt-4 gap-5 z-10 flex justify-center items-start w-screen max-w-screen-2xl mx-auto">
          {/* Stepper */}
          <motion.div
            variants={childVariantsStepper}
            initial="initial"
            animate="final"
            className="hidden md:block mb-12 sticky top-10"
          >
            <StepsTitle
              isChildVisible
              formNo={formNo}
              sellerOrUser={"seller"}
            />
          </motion.div>

          <div className="flex gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md ">
            {formNo === 1 && (
              <>
                <SellerFormStep1
                  isInSeller={true}
                  formNo={formNo}
                  setFormNo={setFormNo}
                  errors={errors}
                  control={control}
                />
              </>
            )}
            {formNo === 2 && (
              <>
                <SellerFormStep2
                  errors={errors}
                  control={control}
                  formNo={formNo}
                  setFormNo={setFormNo}
                  onBack={() => setFormNo(formNo - 1)}
                  setState={setStoreUid}
                />
              </>
            )}
            {formNo === 3 && (
              <>
                <SellerFormStep3
                  formNo={formNo}
                  setFormNo={setFormNo}
                  errors={errors}
                  control={control}
                  storeUid={storeUid}
                />
              </>
            )}
            {formNo === 4 && (
              <>
                <BankAccount
                  formNo={formNo}
                  control={control}
                  setFormNo={setFormNo}
                  storeUid={storeUid}
                  errors={errors}
                  onBack={() => setFormNo(formNo - 1)}
                  setStoreStateConfirmInfo={setStoreStateConfirmInfo}
                />
              </>
            )}
            {formNo === 5 && (
              <>
                <ConfirmInfo
                  storeState={storeState}
                  // storeStateConfirmInfo={(seller_state !== undefined) ? seller_state : storeStateConfirmInfo}
                  formNo={formNo}
                  setFormNo={setFormNo}
                  onBack={() => setFormNo(formNo - 1)}
                  storeStateConfirmInfo={storeStateConfirmInfo}
                />
              </>
            )}
            {formNo === 6 && (
              <>
                <Guarantee
                  formNo={formNo}
                  setFormNo={setFormNo}
                  paymentAmount={"۲٬۳۴۱٬۰۰۰"}
                  onBack={() => setFormNo(formNo - 1)}
                />
              </>
            )}

            {formNo === 7 && (
              <>
                <SellerFormStep7
                  // errors={errors}
                  control={control}
                  // onBack={() => setFormNo(formNo - 1)}
                  formNo={formNo}
                  setFormNo={setFormNo}
                />
              </>
            )}
            {formNo === 8 && (
              <>
                <SellerFormStep8 />
              </>
            )}
          </div>
        </div>
      </div>
      {!accepted && (
        <AcceptSellerPolicy
          modalContentRef={modalContentRef}
          onRulesAccepted={handleRulesAccepted}
        />
      )}
    </motion.div>
  );
}

export default SellerStepper;
